

var PostTypes = function()
{

	var postTypesApp = this;

	/**
	 * [getAttributes description]
	 * @param  {[type]} node [description]
	 * @return {[type]}      [description]
	 */
	this.getAttributes = function( node )
	{
		var attributes = {};
		for( var i in node.attributes ) {
			if( node.attributes.hasOwnProperty( i ) ) {
				attributes[node.attributes[i].name] = node.attributes[i].nodeValue;
			}
		}
		return attributes;
	};

	/**
	 * [modalEdit description]
	 * @param  {[type]} _this [description]
	 * @return {[type]}       [description]
	 */
	this.modalEdit = function( node, _callbacks )
	{
		_callbacks = _callbacks || {};
		var callbacks = $.extend({
			onVisible : function(){},
			onComplete : function(){},
			onError : function(){},
			onSave : function(){},
			onResponse : function(){}
		}, _callbacks);

		var attributes = postTypesApp.getAttributes(node);
		$.get( attributes.href, function( response ) {
			callbacks.onResponse(response, attributes);
			modal = $(response);
			if( modal[0].ownerDocument ) {
				modal.modal({
					observeChanges : false,
	            	onVisible : function() {
	            		var modalObj = $(this);
	            		var button = $('.positive.ui.button', modalObj);
	            		var _token = $('[name="_token"]', modalObj).val();
	            		var form = $('.ui.form', modalObj);
	            		var action = form.attr('action');
	            		button.click(function(e){
	            			e.preventDefault();
	            			callbacks.onSave( $(this), modalObj );
	            			$.ajax({
	                            type: 'POST',
	                            async: false,
	                            headers: {
	                            	'X-CSRF-TOKEN' : _token
	                            },
	                            url: action,
	                            data : $('input, select, textarea', form).not('[name="_token"]').serialize(),
	                            success: function( response ){
	                            	callbacks.onComplete( response, attributes );
	                                modal.modal('hide');
	                            },
	                            error: function ( xhr, textstatus, errorThrown ) {
	                            	switch( xhr.status ) {
	                            		case 422 :
	                            			var errors = [];
	                            			/** Validation error */
	                            			var response = JSON.parse( xhr.responseText );
	                            			for( var i in response ) {
	                            				errors.push( response[i][0] );
	                            			}
	                            			modalError( errors, modal );
	                            		break;
	                            		default :
	                            			modalError( ['Unknown error has occurred: ["' + xhr.status + '","' + textstatus + '"]'], modal );
	                            		break;
	                            	}
	                            	callbacks.onError( modalObj, xhr );
	                            }
	                        });
	            		});
						callbacks.onVisible( modalObj );
	            	}
	        	}).modal('show');
			}
		});
	};

	/**
	 * [select description]
	 * @param  {[type]} selector [description]
	 * @param  {[type]} el       [description]
	 * @return {[type]}          [description]
	 */
	this.select = function( selector, el ) {
		if ( ! el ) { el = document; }
		return Array.prototype.slice.call( el.querySelectorAll( selector ) );
	};

	/**
	 * [modalError description]
	 * @param  {[type]} errors [description]
	 * @param  {[type]} modal  [description]
	 * @return {[type]}        [description]
	 */
	this.modalError = function( errors, modal )
	{
		var wrapper = $('<div class="ui error message"><div class="header">There was some errors with your submission</div><ul class="list"></ul></div>');
		errors.forEach(function(error){
			$('<li />').text(error).appendTo( $( 'ul', wrapper ) );
		});
		$('[data-for="error-wrapper"]', modal).html('').append(wrapper);
		modal.modal('refresh');
	};

	/**
	 * [wysiwyg description]
	 * @return {[type]} [description]
	 */
	this.wysiwyg = function()
	{
		$('.redactor').redactor({
			minHeight : 300,
			toolbarFixed : false,
			fileUpload 	: '/admin/media-manager/upload?_token=' + $('[name="_token"]').val(),
			imageUpload : '/admin/media-manager/upload?_token=' + $('[name="_token"]').val(),
			cleanStyleOnEnter : true,
			deniedTags : ['html', 'head', 'link', 'body', 'meta', 'script', 'style', 'applet', 'span']
		});
	};

	/**
	 * [postType description]
	 * @return {[type]} [description]
	 */
	this.postType = function()
	{

		var pt = this;

		/**
		 * [updateTableRow description]
		 * @param  {[type]} response   [description]
		 * @param  {[type]} attributes [description]
		 * @return {[type]}            [description]
		 */
		this.updateTableRow = function( response, attributes )
		{
			var row =  $('[data-for="fields-list"] [data-field-id="' + response.id + '"]');
			$('[data-for="field-label"]', row).text( response.label );
			$('[data-for="field-type"]', row).text( response.field_type_display );
		};

		/**
		 * [addTableRow description]
		 * @param {[type]} response   [description]
		 * @param {[type]} attributes [description]
		 */
		this.addTableRow = function( response, attributes )
		{
			var row = $('<tr />').attr('data-field-id', response.id);
			var id = $('<td />').attr('data-for', 'field-id').text(response.id);
			var label = $('<td />').attr('data-for', 'field-label').text(response.label);
			var type = $('<td />').attr('data-for', 'field-type').text(response.type_display);
			var buttonsW = $('<td />');
			var buttons = $('<div />').addClass('ui small icon basic buttons');
			var editButton = $('<a />')
				.addClass( 'ui button' )
				.attr( 'data-for', 'edit-field' )
				.attr( 'data-trigger-id', response.id)
				.attr( 'href', response.edit_url)
				.html( '<i class="align edit green icon"></i>' );
			var deleteButton = $('<a />')
				.addClass( 'ui button' )
				.attr( 'data-for', 'delete-field' )
				.attr( 'data-trigger-id', response.id)
				.attr( 'href', response.delete_url)
				.html( '<i class="align trash red icon"></i>' );

			row.append(id).append(label).append(type);
			buttons.append(editButton).append(deleteButton);
			buttons.appendTo(buttonsW);
			row.append(buttonsW);

			var defaultRow = $('[data-for="fields-list"] [data-for="no-results-row"]');
			if( defaultRow.length ) {
				defaultRow.remove();
			}

			row.appendTo($('[data-for="fields-list"]'));
			pt.bindEvents();

		};

		/**
		 * [addDefaultNoResultsRow description]
		 */
		this.addDefaultNoResultsRow = function( tbody )
		{
			var row = $('<tr />').attr('data-for', 'no-results-row');
			$('<td />').attr('colspan', 4).text('You currently have no fields attached').appendTo(row);
			row.appendTo(tbody);
		};

		/**
		 * [removeTableRow description]
		 * @param  {[type]} response   [description]
		 * @param  {[type]} attributes [description]
		 * @return {[type]}            [description]
		 */
		this.removeTableRow = function( response, attributes )
		{
			$('[data-for="fields-list"] tr[data-field-id="' + response.id + '"]').fadeOut(200, function(){
				$(this).remove();
				if( ! $('[data-for="fields-list"] tr').length ) {
					pt.addDefaultNoResultsRow( $('[data-for="fields-list"]') );
				}
			});
		};

		/**
		 * [fieldEditHandler description]
		 * @return {[type]} [description]
		 */
		this.fieldEditHandler = function(e)
		{
			e.preventDefault();
			postTypesApp.modalEdit( this, {
				onVisible : function( modalObj ){
					$('.redactor', modalObj).redactor({
						minHeight : 300,
						toolbarFixed : false,
					});
					setTimeout( function(){
						modalObj.modal('refresh');
					}, 500);
				},
				onComplete : function( response, attributes ){
					pt.updateTableRow( response, attributes );
				}
			});
		};

		/**
		 * [addFieldHandler description]
		 * @param {[type]} e [description]
		 */
		this.addFieldHandler = function(e)
		{
			e.preventDefault();
			postTypesApp.modalEdit( this, {
				onVisible : function( modalObj ){
					$('.redactor', modalObj).redactor({
						minHeight : 300,
						toolbarFixed : false
					});
					setTimeout( function(){
						modalObj.modal('refresh');
					}, 500);
				},
				onComplete : function( response, attributes ){
					pt.addTableRow( response, attributes );
				}
			});
		};

		/**
		 * [deleteFieldHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		this.deleteFieldHandler = function(e)
		{
			e.preventDefault();
			postTypesApp.modalEdit( this, {
				onResponse : function( response, attributes ){
					pt.removeTableRow( response, attributes );
				}
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		this.bindEvents = function()
		{
			postTypesApp.select('[data-for="edit-field"]').forEach(function(elm){
				elm.removeEventListener( 'click', pt.fieldEditHandler );
				elm.addEventListener( 'click', pt.fieldEditHandler );
			});
			postTypesApp.select('[data-for="add-new-field"]').forEach(function(elm){
				elm.removeEventListener( 'click', pt.addFieldHandler );
				elm.addEventListener( 'click', pt.addFieldHandler );
			});
			postTypesApp.select('[data-for="delete-field"]').forEach(function(elm){
				elm.removeEventListener( 'click', pt.deleteFieldHandler );
				elm.addEventListener( 'click', pt.deleteFieldHandler );
			});
		};


		return new (function(){

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				pt.bindEvents();
			};

		});

	};

	/**
	 * [init description]
	 * @return {[type]} [description]
	 */
	this.init = function()
	{

		var postTypeApp = new postTypesApp.postType();
		postTypeApp.init();

		postTypesApp.wysiwyg();
	};


};


jQuery(document).ready( function($){

	if( $('.create.post-type, .edit.post-type, .edit.post-type-post, .create.post-type-post').length )
	{
		$('.orderable').rowSorter({
			onDrop: function(tbody, row, new_index, old_index) {
		        var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
		        var ids = [];
		        $('tbody tr', table).each(function(){
		        	ids.push( $(this).attr('data-field-id') );
		        });
		        $.ajaxSetup({
		            headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() }
		        });
		        $.post( $('#order-url').val(), { orders : ids }, function( response ){
		        	console.log(response);
		        });
		    },
		});

		var app = new PostTypes();
		app.init();
	}


	if( $( '.posts.list' ).length ) {
		var wrapper = $( '.posts.list' );
		var postTypeID = $('[name="post_type_id"]', wrapper).val();
		var token = $('[name="_token"]').val();
		var url = $('[name="order_url"]').val();
		$('.orderable').rowSorter({
			onDrop: function(tbody, row, new_index, old_index) {
		        var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
		        var ids = [];
		        $('tbody tr', table).each(function(){
		        	ids.push( $(this).attr('data-field-id') );
		        });
		        $.ajaxSetup({
		            headers: { 'X-CSRF-TOKEN': token }
		        });
		        $.post( url, { orders : ids }, function( response ){
		        	console.log(response);
		        });
		    },
		});
	}

});